@if(ExceptionCodesDetails.length > 0){
<mat-list-item class="cais-list-item-title">Error Code Details</mat-list-item>
<!-- Error Code Details Field -->
<div class="ui-grid-col-12 container">
  @for (exceptionRow of ExceptionCodesDetails; track exceptionRow.failureCode + '-'+ $index; let i = $index){
  <span [ngClass]="'zindex ui-g-12 ui-md-12 ui-lg-12'">
    <span>
      <div class="ui-g-12 ui-md-3 ui-lg-3 quick-view-grid-row-hg">
        <div [ngClass]="'ui-g-12 ui-md-5 ui-lg-5 quick-view-grid-row-hg'">
          <label for="ErrorCode">Error Code</label>
        </div>
        <div [ngClass]="'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg'">
          <span>
            <input [disabled]="true" pInputText [(ngModel)]="exceptionRow.failureCode"
              [title]="exceptionRow.failureCode" />
          </span>
        </div>
      </div>
      <div class="ui-g-12 ui-md-9 ui-lg-9 quick-view-grid-row-hg">
        <div [ngClass]="'ui-g-12 ui-md-2 ui-lg-2 quick-view-grid-row-hg'">
          <label for="Description">Description</label>
        </div>
        <div [ngClass]="'ui-g-12 ui-md-10 ui-lg-10 quick-view-grid-row-hg'">
          <span>
            <input [disabled]="true" pInputText [(ngModel)]="exceptionRow.failureDescription"
              [title]="exceptionRow.failureDescription" />
          </span>
        </div>
      </div>
    </span>
  </span>
}
</div>
<!-- End of Error Code Details Field -->
<mat-divider></mat-divider>
}